import { render } from "./VacancyDropdown.vue?vue&type=template&id=e39ce7c0"
import script from "./VacancyDropdown.vue?vue&type=script&lang=js"
export * from "./VacancyDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__